import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import {
  getAllCleanerShifts,
  getuserinformation,
  savereminderdata,
  savetasksdata,
  savevehicledata,
  updateItem,
} from "../../utils/firebasefunctions";
import { FaUser } from "react-icons/fa";
import userlogo from "../images/user.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { RotatingLines } from "react-loader-spinner";
import { IoIosCloseCircle } from "react-icons/io";
import { actionType } from "../context/reducer";
import { ToastContainer, toast } from "react-toastify";
import { FaCircleMinus } from "react-icons/fa6";
import carlogo from "../images/car.png";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { FaCar } from "react-icons/fa";
import {
  arrayUnion,
  collection,
  doc,
  onSnapshot,
  query,
} from "firebase/firestore";
import { firestored, storage } from "../../firebase.config";

import { useStateValue } from "../context/StateProvider";
import EmployeePopup from "./EmployeePopup";

const containerStyle = {
  width: "100%",
  minHeight: "100%",
};

const TaskRejection = (props) => {
  const [{ user, employees }, dispatch] = useStateValue();
  const [employeedata, setemployeedata] = useState();
  const [employeepopup, setemployeepopup] = useState(false);
  const [remindertime, setremindertime] = useState("12:00");
  const [selectedemployee, setselectedemployee] = useState([]);
  const [taskloader, settaskloader] = useState(false);
  const [loader, setloader] = useState(false);

  const [rejectionreason, setrejectionreason] = useState("");
  const [selecteddate, setselecteddate] = useState(new Date());

  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        setrejectionreason("");

        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  const Heading = (title) => {
    return <p className="pt-[10px] PoppinsRegular  text-textcolor ">{title}</p>;
  };

  return (
    props.visible && (
      <div className="position absolute z-10  top-[0] left-[0] w-full h-full bg-[rgba(211,211,211,0.4)] flex items-center justify-center ">
        <div
          ref={popupref}
          className="w-[80%] lg:w-[600px]   bg-themelightblack border border-bordercolor  rounded-xl  gk-scr  flex items-center justify-center flex-col    px-[20px] "
        >
          <div className="flex w-full h-[100%] relative flex-col pt-[10px] pb-[20px]  overflow-scroll ">
            {Heading("Reject Task")}

            <div className=" w-full mt-[10px] ">
              <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                Reason
              </p>
              <textarea
                type="text"
                placeholder="Enter task rejection reason..."
                rows={1}
                value={rejectionreason}
                onChange={(event) => {
                  console.log(event.target.value);
                  setrejectionreason(event.target.value);
                }}
                className={`input relative px-4 text-black text-sm  PoppinsRegular w-full h-[90px] md:h-[125px] rounded-xl border border-themeColor items-center flex`}
              />
            </div>
            {loader ? (
              <div className=" py-4  mt-6 w-full flex justify-center  ">
                <RotatingLines
                  visible={true}
                  height="25"
                  width="25"
                  color="grey"
                  strokeColor="#00C763"
                  strokeWidth="5"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <button
                onClick={() => {
                  props.reject(rejectionreason);
                }}
                type="submit"
                className={`mt-[20px] text-center py-3 rounded-lg  bg-red-600 hover:bg-red-600/80  text-white
                px-[10px]  text-sm  PoppinsRegular uppercase bg-cardOverlay  drop-shadow-lg`}
              >
                Reject
              </button>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default TaskRejection;
